module.exports = __webpack_public_path__ + "static/media/delete-icon.ee0d0716.svg";